import React from "react";

import withPermissions from "permissions/withPermissions";
import DefaultPageLayout from "components/layouts/default-page-layout";
import { useSelector } from "react-redux";
import { getSignedInOrgUnit } from "app/auth/store/reducers/user.reducer";
import UserImportLogTable from "../components/user-import-log-table";

const UserImportLogPage = ({
  hasPermissionBulkUserImportLogView,
}) => {
  const signedInOrgUnit = useSelector(getSignedInOrgUnit);

  return (
    <DefaultPageLayout
      accessDenied={!hasPermissionBulkUserImportLogView}
      content={<UserImportLogTable orgUnit={signedInOrgUnit} />}
    />
  );
};

export default withPermissions("BulkUserImportLogView")(UserImportLogPage);
